import React, { useContext, useEffect, useState } from 'react'
import Container from 'components/container'
import Header from 'components/header'
import Footer from 'components/footer'
import styles from './thankyoueoi.module.scss'
import IframeResizer from 'iframe-resizer-react'
import { AppContext } from 'state'

import {
  Footer as FooterProp,
  Header as HeaderProp
} from 'state/types'



const ThankyouEoiView: React.FC = () => {

  const { platesJson } = useContext(AppContext)
  const mainUrl = `${process.env.REACT_APP_DOT_SERVER_URL}`+platesJson.ThankyouEoi?.url?.filename_url
  const [footer, setFooter] = useState<FooterProp | null>(
    (platesJson.footer) || null
  )
  const [header, setHeader] = useState<HeaderProp | null>(
    (platesJson.header) || null
  )

  useEffect(() => {
    if (platesJson.footer) {
      setFooter(platesJson.footer)
    }
    if (platesJson.header) {
      setHeader(platesJson.header)
    }
  }, [platesJson])
  return (
    <>
      <div style={{minHeight:window.innerHeight}}>
        <Container full className={styles.headerBg}>
          {/* <Container> */}
          {header && <Header {...header} />}
          {/* </Container> */}
        </Container>
          <IframeResizer
            //forwardRef={iframeRef}
            heightCalculationMethod="lowestElement"
            inPageLinks
            log
            //onMessage={onMessage}
            //onResized={onResized}
            src={mainUrl}
            style={{ width: '1px', minWidth: '100%', height: '180vh'}}
          />
        <Container full className={styles.footerBg}>
          {footer && <Footer {...footer} />}
        </Container>
      </div>
    </>
  )
}

export default ThankyouEoiView
